import React from "react";
import { Navigate } from "react-router-dom";
import Orders from "../pages/Order";
import OrderDetails from "../pages/Order/view";

const protectedRoutes = [
  { path: "/", element: <Orders /> },
  { path: "/orderdetails/:id", element: <OrderDetails /> },
  { path: "*", element: <Navigate to="/" /> },
];
export default protectedRoutes;
